import { RectangleMarkerStateManager } from '../rectangle/rectangleMarkerStateManager'

class SelectionMarkerStateManager extends RectangleMarkerStateManager {
  protected _strokeWeight = 1.5

  constructor(marker) {
    super(marker)
  }
}

export { SelectionMarkerStateManager }
